import type { IconProps } from './IconProps';

export const ChevronDownSmallFilledIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M11.3334 5.5C11.6705 5.5 11.9743 5.70299 12.1033 6.01433C12.2323 6.32573 12.161 6.68421 11.9226 6.92254L8.58927 10.2559C8.26383 10.5814 7.73631 10.5814 7.41087 10.2559L4.07749 6.92254C3.83916 6.68421 3.76784 6.32573 3.89683 6.01433C4.02584 5.70299 4.32968 5.5 4.66669 5.5H11.3334Z"
      fill="currentColor"
    />
  </svg>
);
